import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';
import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  fallbackRender?: (props: FallbackProps) => ReactNode;
  onReset?: () => void;
}

function handleError(error: Error, info: { componentStack?: string | null }) {
  Sentry.captureException(error, {
    extra: {
      componentStack: info.componentStack,
    },
  });
}

export function ErrorBoundary({
  children,
  fallback,
  fallbackRender,
  onReset,
}: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      fallback={fallback}
      fallbackRender={fallbackRender}
      onError={handleError}
      onReset={onReset}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export { type FallbackProps } from 'react-error-boundary';
